<template>
    <div class="page-about">
        <top-navbar :menu-opened.sync="menuOpened" />
        <app-menu :active.sync="menuOpened" :bottom="true" />
        <div class="about-banner">
            <div class="about-banner-cover">
                <div class="site-container site-section-v">
                    <h1>Sobre Nós</h1>
                    <p>A Crivelli Advogados Associados conta com mais de 35 anos de experiência, sempre pautada por um posicionamento de vanguarda na advocacia, alicerçada no objetivo de construir uma sociedade mais justa e igualitária. Nossa marca tem o compromisso de se reinventar todo dia para oferecer uma advocacia diferenciada, técnica, combativa e crítica à altura dos desafios das novas tecnologias para a advocacia e para o mundo do trabalho.

                    </p>
                </div>
            </div>
        </div>
        <div class="about-banner-card">
            <iframe width="530" height="315" src="https://www.youtube-nocookie.com/embed/jxD7hNHj_j0?controls=0" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
        </div>
        <!-- <img src="@/assets/img/card_about.png" class="about-banner-card"> -->
        <section class="site-section-v">
            <div class="about-location site-container">
                <div class="location-text text-grey-dark">
                   Ao longo de quase quatro décadas a Crivelli Advogados Associados se destacou como um dos maiores escritórios do país especializados em direito sindical, trabalhista e previdenciário, com um atendimento integral e de excelência. Ética, transparência e absoluta fidelidade aos direitos humanos são cláusulas pétreas de nossa própria constituição.

O escritório conta com uma equipe de profissionais qualificados para a atuação judicial e a assessoria, diante dos desafios crescentes do mundo social e jurídico contemporâneo. Por isso sempre buscou estar junto das principais iniciativas das entidades sindicais, jurídicas e acadêmicas do país, em um constante processo de atualização e fomento do debate qualificado. Nesse sentido, conta com diversos grupos de trabalho voltados à pesquisa e produção de informações, em especial, para debater e criar soluções para as pautas LGBTs, raciais e vinculadas à igualdade das mulheres. 


                </div>
                <img src="@/assets/img/svg/brasil.svg" alt="Localizações da Crivelli" title="Localizações da Crivelli"
                     width="400">
            </div>
        </section>

        <section class="about-items site-section-v site-container">
            <div class="about-item">
                <h3 class='text-orange'>Missão</h3>
                <p class="text-grey-dark">Prestar serviços jurídicos na defesa do cliente com rapidez, qualidade,
                    transparência, ética e respeito, utilizando instrumentos do Direito, que mesclam o tradicional e o
                    inovador.</p>
            </div>
            <div class="about-item">
                <h3 class="text-orange">Visão</h3>
                <p class="text-grey-dark">Ser reconhecida como uma Sociedade de Advogados líder, dotada de padrões de
                    excelência técnica em diversificadas áreas do Direito.</p>
            </div>
            <div class="about-item">
                <h3>Valores</h3>
                <p class="text-grey-dark">
                    <ul>
                        <li>Assumir as necessidades dos clientes, persistindo na busca de soluções;</li>
                        <li>Ser empreendedor;</li>
                        <li>
                            Agir com honestidade, integridade e ousadia;</li>
                        <li>
                            Evoluir permanentemente;</li>
                        <li>
                            Manter ambiente de trabalho saudável,
                            participativo e produtivo;</li>
                        <li>
                            Respeitar e fazer respeitar os direitos dos
                            nossos clientes;
                        </li>
                        <li>Desenvolver e manter práticas sustentáveis.</li>
                    </ul>
                </p>
            </div>
        </section>

        <section class="about-story site-section-v">
            <div class="site-container">
                <h2 class="text-blue"><img src="@/assets/img/svg/icon.svg" width="70" class="icon">
                    Nossa História</h2>
                <div class="about-story-text text-grey-dark">
                    <div class="image">
                        <logo-icon  />
                        <img src="@/assets/img/man_about.png" alt="">
                    </div>
                    <p>A história da Crivelli Advogados Associados está entrelaçada com a história de seu sócio-fundador, Ericson Crivelli, e espelha a trajetória do Brasil ao longo das ultimas décadas. A história se iniciou junto dos movimentos sociais em 1979, momento em que a ditadura militar reprimia fortemente os direitos políticos e trabalhistas, quando Ericson Crivelli participava dos movimentos estudantil e começou seus trabalhos com o movimento sindical. E por isso, o escritório é herdeiro das lutas contra a ditadura e do anseio de construção de uma sociedade emancipada.</p>
                    <p>O escritório Crivelli Advogados Associados foi fundado em 1987, tendo no ano seguinte assessorado o Plano de Negociação Nacional dos Bancários e, posteriormente, em 1992, foi redator da primeira Convenção de Trabalho Nacional dos Bancários. Foi, por 20 anos, o principal consultor jurídico da CUT, dedicado a defesa dos interesses da classe trabalhadora e da democracia dentro e fora do país.
</p>
                    <p>Em 1996 o escritório passou a atuar na área internacional, quando Crivelli integrou a Comissão Ad Hoc sobre a Dimensão Social que em 1998 propôs o texto da Declaração Sociolaboral do Mercosul, que permanece vigente até hoje. Crivelli integrou tal comissão até o ano de 2014.
</p>
<p>
Em 2004 foi eleito presidente da Comissão de Assessoramento Jurídico Sindical (COSATE) da Organização dos Estados Americanos (OEA). Além disso, integrou, durante 20 anos, a Comissão de Normas da Organização Internacional do Trabalho (OIT).
</p><p>
Lecionou Direito Internacional do Trabalho no Centro de Formação da OIT em Turim, Itália entre 2003 e 2007. Atualmente ocupa uma das vice-presidências do Internacional Centre for Trade Union Rights (ICTUR) com sede em Londres.
</p><p>
O posicionamento ético e o envolvimento profissional competente e comprometido com as causas trabalhistas, de saúde e previdenciárias, tornou o Escritório um dos mais respeitados nas áreas de direito trabalhista individual e coletivo, tendo atendido com excelência diversos sindicatos, com destaque para os Bancários, Professores (APEOESP e Universitários) e Petroleiros.
</p><p>
Em 2017, o escritório se associou ao IBGC (Instituto Brasileiro de Governança Corporativa) funcionando desde então com Regras de Governança Corporativa, que consolidam a cultura interna voltada para a ética e visam bons resultados por meio da análise de risco e da vigilância interna. 
</p><p>
Desde 2013 o escritório vem investindo em tecnologia e na transformação digital, com a criação do sistema de gestão de processos Tarsila, e sempre alinhado às melhores praticas para seguir prestando um serviço de excelência, utilizando as ferramentas e tecnologias mais modernas para um serviço de qualidade e rapidez.
</p>

                </div>
            </div>
        </section>
    </div>
</template>

<script>
import TopNavbar from "@/components/Page/TopNavbar.vue";
import Menu from "@/components/Menu.vue";
import LogoIcon from "@/components/Svg/LogoIcon";

export default {
  components: { TopNavbar, "app-menu": Menu, LogoIcon },

  data() {
    return {
      menuOpened: false,
    };
  },
};
</script>

<style>
</style>
